import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faFileInvoice, faFileCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { SlidingPills, type TabOption } from '../../../components/ui/SlidingPills';
import InvoiceList from './InvoiceList';
import NewInvoiceForm from './NewInvoiceForm';
import { type Invoice } from '../api';

const InvoicesDashboard: React.FC = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('list');
    const [editingInvoice, setEditingInvoice] = useState<Invoice | null>(null);

    const tabs: TabOption[] = [
        { id: 'list', label: t('invoices.dashboard.tabs.myInvoices'), icon: faFileInvoice },
        { id: 'new', label: t('invoices.dashboard.tabs.newInvoice'), icon: faFileCirclePlus },
    ];

    return (
        <div data-ui="invoices-page" className="page-theme-surface page-theme-invoices flex flex-col h-full w-full p-8 gap-8 overflow-y-auto custom-scrollbar relative">
            <div data-ui="invoices-dashboard-region-001" className="flex flex-wrap items-center justify-between gap-4 relative z-10">
                <div data-ui="invoices-dashboard-region-002" className="flex flex-col gap-2">
                    <h1 className="text-3xl font-bold tracking-tight text-white">
                        {t('invoices.dashboard.title')}
                    </h1>
                    <p className="text-white font-medium">
                        Gestiona tus facturas, borradores y registros fiscales
                    </p>
                </div>
                <div data-ui="invoices-dashboard-region-003" className="flex justify-center">
                    <SlidingPills 
                        options={tabs} 
                        activeId={activeTab} 
                        onChange={(id) => {
                            setEditingInvoice(null);
                            setActiveTab(id);
                        }}
                        size="md"
                    />
                </div>
            </div>

            <div data-ui="invoices-dashboard-region-004" className="w-full relative z-10">
                {activeTab === 'list' && !editingInvoice && (
                    <InvoiceList 
                        onEditInvoice={(invoice) => {
                            setEditingInvoice(invoice);
                        }} 
                    />
                )}
                {(activeTab === 'new' || (activeTab === 'list' && editingInvoice)) && (
                    <NewInvoiceForm 
                        invoiceToEdit={activeTab === 'list' ? editingInvoice : null}
                        onSuccess={() => { 
                            setEditingInvoice(null);
                            setActiveTab('list'); 
                        }} 
                        onCancel={() => {
                            setEditingInvoice(null);
                            setActiveTab('list'); 
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default InvoicesDashboard;
